var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.159,
    height: 13.49,
    viewBox: "0 0 8.159 13.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1210.999 -496.999)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 5.331,
    y2: 5.331,
    transform: "translate(1212.413 498.414)",
    fill: "none",
    stroke: "#e96e22",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.331,
    y2: 5.331,
    transform: "translate(1212.413 503.745)",
    fill: "none",
    stroke: "#e96e22",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3f5df2f96fbb59685fc09641a00a3718.svg";
export { ForwardRef as ReactComponent };